var r = /* @__PURE__ */ ((a) => (a.Static = "static", a.Cloudinary = "cloudinary", a))(r || {}), t = /* @__PURE__ */ ((a) => (a.Compact = "compact", a.Comfortable = "comfortable", a))(t || {});
export {
  t as S,
  r as a
};
//# sourceMappingURL=misc-CHQs-G03.js.map
